import { CACHE_MANAGER } from "../utils.js";

/**
 *
 * @param {Spinner} spinner
 * @class
 */
function Renderer(spinner) {
  this.spinner = spinner;
  this.frameThrottle = null;
  this.viewerNode = spinner.viewerLayer.subject;
}

Renderer.prototype = {
  highQualityThrottle: null,

  get images() {
    return this.spinner.activeLayer.images;
  },

  get activeLayerType() {
    return this.spinner.activeLayer.type;
  },

  /**
   * Overwrite this function and add your business logic
   * @param {number} row
   * @param {number} column
   * @returns {string}
   */
  getCurrentFrame(row, column) {
    const _spinner = this.spinner;
    const image = this.images[`${column}-${row}`];
    const url = image.url || `${_spinner.imagesBaseUrl}/${image.hash}.1920`;

    if (CACHE_MANAGER.isReady(url)) {
      return CACHE_MANAGER.get(url);
    }

    clearTimeout(this.highQualityThrottle);
    this.highQualityThrottle = setTimeout(() => {
      CACHE_MANAGER.image(url).then(() => {
        this.update(_spinner.activeRow, _spinner.activeColumn);
      });
    }, 250);

    return CACHE_MANAGER.getOrFallback(
      image.url ||
        `${_spinner.imagesBaseUrl}/${image.hash}.${_spinner.initialImageSize}`,
    );
  },

  /**
   * Overwrite this function and add your business logic
   * @param {number} row
   * @param {number} column
   */
  update(row, column) {
    cancelAnimationFrame(this.frameThrottle);
    this.frameThrottle = requestAnimationFrame(() => {
      const src = this.getCurrentFrame(row, column);
      this.viewerNode.src = src;

      requestAnimationFrame(() => {
        for (let i = 0, len = this.updateHandlers.length; i < len; i++) {
          this.updateHandlers[i](this.activeLayerType, src);
        }
      });
    });
  },

  updateHandlers: [],

  /**
   *
   * @param {Function} handler
   */
  addOnUpdate(handler) {
    this.updateHandlers.push(handler);
  },

  reset() {
    this.updateHandlers = [];
  },
};

export default Renderer;
